module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee@3x_2841ca.jpg";